module.exports = __webpack_public_path__ + "static/california-0ce1187bc5515d3626976946c9963e10.webp";